import { useEffect, useState } from "react";
import { ReleaseApi } from "../api";
import { AdminFeedbackPanel } from "./AdminFeedbackPanel";
import { ReleaseManagerPanel } from "./ReleaseManagerPanel";

// The release list is admin-only: it fails for everyone else, so a successful
// load is the signal that the Admin tab should be shown. One request on mount.
export const useIsAdmin = (): boolean => {
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    let cancelled = false;
    ReleaseApi.getAll()
      .then((res) => {
        if (!cancelled && res.success) setIsAdmin(true);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);

  return isAdmin;
};

export const AdminView = () => (
  <div className="space-y-8">
    <ReleaseManagerPanel />
    <AdminFeedbackPanel />
  </div>
);
